import HealthcareHero from '../../organisms/HealthcareHero/HealthcareHero'
import HealthcareDetails from '../../molecules/HealthcareDetails/HealthcareDetails'
import ComplianceExpertise from '../../molecules/ComplianceExpertise/ComplianceExpertise'
import CaseHighlight from '../../molecules/CaseHighlight/CaseHighlight'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import CommonHeroSection from '../../organisms/commonherosection/CommonHeroSection'
const IndustryHealthcarePage = () => {
  return (
    <main className="min-h-screen bg-[#0E0924] text-white">
      <CommonHeroSection> <HealthcareHero /> </CommonHeroSection>
      <HealthcareDetails />
      <ComplianceExpertise />
      <CaseHighlight />
      <Testimonial className="mx-auto mb-20 max-w-[90%]" showHeader />
      <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
      <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
          <Message />
          <Questions />
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default IndustryHealthcarePage
